import "./CheckMailComponent.scss";
import React, {useCallback} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import {ArrowBack} from "@mui/icons-material";
import commonService from "../../../shared/services/common.service";
import {ImageConfig} from "../../../constants";
import {CommonService} from "../../../shared/services";
import LottieFileGenarationComponent
    from "../../../shared/components/core/lottie-file-genaration/LottieFileGenarationComponent";

interface CheckMailComponentProps {

}

const CheckMailComponent = (props: CheckMailComponentProps) => {
    const params = useParams<{ "emailId": string }>();
    let emailId = params.emailId;
    const navigate = useNavigate();
    const location = useLocation();

    const handleNavigation = useCallback((route: string) => {
        let returnUrl = CommonService._routeConfig.Dashboard();
        const query = CommonService.parseQueryString(location.search);
        if (Object.keys(query).includes('returnUrl')) {
            returnUrl = query.returnUrl;
        }
        navigate(route + `?returnUrl=${returnUrl}`);
    }, [location, navigate]);

    const resendLinkToEmail = useCallback(() => {
        const payload = {emailId: emailId?.toLowerCase()};
        commonService._account.sendForgotPasswordEmail(payload).then((response: any) => {
            commonService._alert.showToast("Email sent successfully", "success")
        })
            .catch((error: any) => {
                commonService._alert.showToast("Error sending Email", "error")
            })
    }, [emailId]);

    return (
        <div className={'check-email-component screen width-100'}>
            <div className="check-mail-title auth-form-title">
                Check your email!
            </div>
            <div className="check-mail-description auth-form-description">
                We’ve sent a reset password link to <b>{emailId}</b>
            </div>
            <div className={"check-email-mail-image-wrapper"}>
                {/*<img src={ImageConfig.CheckYourMailGif} alt={'...loading'}/>*/}
                <LottieFileGenarationComponent
                    height={"264px"}
                    width={"100%"}
                    loop={true}
                    autoplay={true}
                    animationData={ImageConfig.SendEmailLottieFile}/>
                <div className={'check-email-resend-link-wrapper'}>
                    <div className={'check-email-resend-link-text'}>Didn’t receive the email?</div>
                    <div className={'check-email-resend-link'} onClick={() => {
                        resendLinkToEmail()
                    }}>Click to resend
                    </div>
                </div>
            </div>
            <div className={"check-email-mail-actions-wrapper"}>
                <ButtonComponent
                    // isLoading={isLoggingIn}
                    variant={"text"}
                    startIcon={<ArrowBack/>}
                    type={"submit"}
                    color={"primary"}
                    className={'mrg-top-40'}
                    handleClick={() => {
                        handleNavigation(commonService._routeConfig.LoginRoute())
                    }}
                    size={"large"}
                    fullWidth={true}
                    id={"login_btn"}
                >
                    Back to login
                </ButtonComponent>
            </div>
        </div>
    );

};

export default CheckMailComponent;
